import type { ButtonProps } from "@mui/material";
import classNames from "classnames";
import type { FC } from "react";
import { AppButton } from "../../../../../shared/components/AppButton";
import { AppIconButton } from "../../../../../shared/components/AppIconButton";
import { TransferIcon } from "../../../../../shared/icons/TransferIcon";
import styles from "../styles.module.css";

interface Props extends ButtonProps {
  isDisabled?: boolean;
  className?: string;
  handleClick?: () => void;
}

export const TransferObjectButton: FC<Props> = ({
  isDisabled,
  handleClick,
  className,
}) => {
  return (
    <AppIconButton
      onClick={handleClick}
      disabled={isDisabled}
      className={classNames(
        styles.button,
        styles["transfer-button"],
        className
      )}
    >
      <TransferIcon />
    </AppIconButton>
  );
};
